import { Expose } from 'class-transformer';
import { Language } from './language';
export class Config {
  @Expose({ name: 'is_active' })
  is_active!: boolean;

  key!: string;
  name!: string;

  @Expose({ name: 'negative_review_prompt_header' })
  negativeReviewPromptHeader!: string;

  @Expose({ name: 'default_language' })
  defaultLanguage!: Language;

  @Expose({ name: 'negative_review_prompt_body' })
  negativeReviewPromptBody!: string;

  @Expose({ name: 'review_request_subheader' })
  reviewRequestSubheader!: string;

  @Expose({ name: 'negative_review_header' })
  negativeReviewHeader!: string;

  @Expose({ name: 'negative_review_body' })
  negativeReviewBody!: string;

  @Expose({ name: 'positive_review_header' })
  positiveReviewHeader!: string;

  @Expose({ name: 'positive_review_body' })
  positiveReviewBody!: string;

  @Expose({ name: 'review_request_header' })
  reviewRequestHeader!: string;

  @Expose({ name: 'review_request_body' })
  reviewRequestBody!: string;

  @Expose({ name: 'positive_rating_start' })
  positiveRatingStart!: number;

  @Expose({ name: 'should_acquire_email' })
  shouldAcquireEmail!: boolean;

  @Expose({ name: 'should_acquire_phone_number' })
  shouldAcquirePhoneNumber!: boolean;

  @Expose({ name: 'privacy_policy_file_link' })
  privacyPolicyFileLink!: boolean;

  @Expose({ name: 'color_1' })
  bgColor!: string;

  @Expose({ name: 'color_2' })
  primaryColor!: string;

  @Expose()
  logo!: string | null;

  slug!: string;
  company!: number;
  parent!: number | null;
}
